export const ACCOUNT_TYPES = {
  Main: 'Main',
  Trading: 'Trading',
  Commission: 'Commission',
} as const;

export type AccountTypeName = keyof typeof ACCOUNT_TYPES;

export type AccountLeverageDto = {
  isLocked: boolean;
  frozenLeverage: number;
  name: string;
  value: number;
};

export type AccountInfoDto = {
  accTypeName: AccountTypeName;
  accNum: string;
  accName?: string;
  created: string;
  tradingAccKey?: number;
  tradingProductCode?: string;
  tradingProductName?: string;
  leverage?: AccountLeverageDto;
};

export type AccountsInfoResponseDto = {
  autoRefeshCache: number;
  restsCacheLifeTime: number;
  accounts: Array<AccountInfoDto>;
};
